<template>
	<div class="container" :class="{ open: isOpen }"></div>
</template>

<script>
export default {
	name: 'Sidebar',
	props: {
		isOpen: {
			type: Boolean,
			default: null,
		},
	},
}
</script>

<style lang="scss" scoped>
.container {
	width: 0;
	transition: width ease-in 0.5s;
	&.open {
		width: 300px;
	}
}
</style>
